import { useState } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import Button from "../../../ui-lib/components/Button/Button";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";
import { RowData } from "../ObjectsTable";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import { batchCancelTemporaryHandling } from "../../../core/api/alarmhandlings";
import useUser from "../../../core/user/useUser";
import { notify } from "../../../ui-lib/components/Alerts/Toast";

export const CancelTempAHBatch = ({
  items,
  onSuccess,
}: {
  items: RowData[];
  onSuccess: () => void;
}) => {
  const { authenticatedRequest } = useUser();
  const t = useTranslations();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const ids = items.map((i) => i.id);
      await batchCancelTemporaryHandling(authenticatedRequest, ids);
      notify({
        message: t("Objects:success_batch_cancel_temporary_handlings"),
      });
      setOpen(false);
      onSuccess();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors, error?.response?.status);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        text={`${t("Objects:change_selection")} (${items.length})`}
        onClick={() => setOpen(true)}
      />
      <PrimeModal
        withHeader
        withFooter
        fixedWidth="576px"
        isOpen={open}
        loading={loading}
        onClose={() => setOpen(false)}
        header={t("Objects:Cancel temporary alarm handling")}
        submitBtn={{
          text: `${t("Objects:cancel_temporary_alarm_handling")} (${items.length})`,
          onClick: () => onSubmit(),
          variant: "destructive",
        }}
        cancelBtn={{ text: t("Common:cancel"), onClick: () => setOpen(false) }}
      >
        <p>{t("Objects:batch_cancel_temporary_handlings_description")}</p>
      </PrimeModal>
    </>
  );
};
